import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import PageWrapper from "../components/PageWrapper";

const faq = [
  {
    question: "Czy możemy się wcześniej spotkać?",
    answer:
      "Oczywiście! Najlepiej porozmawiać na żywo lub online. Chętnie wysłucham Waszych pomysłów i opowiem, jak może wyglądać Wasz dzień z moją oprawą muzyczną."
  },
  {
    question: "Jak zarezerwować termin?",
    answer:
      "Wystarczy kontakt – formularz, telefon lub wiadomość. Po potwierdzeniu dostępności terminu podpisujemy umowę i wszystko jest dopięte."
  },
  {
    question: "Czy grasz muzykę biesiadną lub tradycyjną?",
    answer:
      "Tak, repertuar dopasowuję do charakteru imprezy i preferencji gości. Gram zarówno współczesne hity, jak i klasyki oraz biesiadne utwory – wszystko z wyczuciem."
  },
  {
    question: "Czy prowadzisz oczepiny i zabawy weselne?",
    answer:
      "Tak – prowadzę zabawy, konkursy i oczepiny w sposób kulturalny, z humorem, ale z klasą. Dobieram je do stylu Pary Młodej i gości."
  },
  {
    question: "Czy możesz współpracować z zespołem lub innym DJ-em?",
    answer:
      "Tak, mam doświadczenie we współpracy z zespołami muzycznymi, wokalistami i DJ-ami. Wszystko zależy od wcześniejszych ustaleń."
  },
  {
    question: "Czy możesz zagrać dedykowane utwory (np. pierwszy taniec)?",
    answer:
      "Jak najbardziej – możecie wskazać konkretne utwory, które mają się pojawić, lub których nie chcecie. Dostosowuję się do Waszych potrzeb."
  },
  {
    question: "Czy prowadzisz tylko wesela?",
    answer:
      "Nie tylko – obsługuję również studniówki, imprezy firmowe, jubileusze, gale, bankiety i inne wydarzenia okolicznościowe."
  },
  {
    question: "Czy masz swój sprzęt nagłośnieniowy i oświetleniowy?",
    answer:
      "Tak – zapewniam kompletny sprzęt nagłośnieniowy i oświetleniowy, dopasowany do wielkości sali i rodzaju wydarzenia."
  },
  {
    question: "Czy oferujesz nagłośnienie ślubu plenerowego?",
    answer:
      "Tak – posiadam mobilne nagłośnienie idealne na śluby w plenerze, z mikrofonem i odtwarzaniem muzyki w tle."
  },
  {
    question: "Jak wygląda sprawa z zaliczką?",
    answer:
      "Zaliczka to zazwyczaj ok. 20–30% wartości usługi. Dokładną kwotę i termin wpłaty ustalamy indywidualnie przy podpisaniu umowy."
  },
  {
    question: "Czy masz zapasowy sprzęt w razie awarii?",
    answer:
      "Tak, zawsze mam backup podstawowego sprzętu – dbam o ciągłość imprezy i jestem przygotowany na każdą ewentualność."
  },
  {
    question: "Czy obsługujesz imprezy w mojej okolicy?",
    answer:
      "Działam głównie na terenie Podkarpacia, ale bez problemu dojeżdżam również w inne regiony Polski – wystarczy się skontaktować."
  },
  {
    question: "Czy można zobaczyć Cię wcześniej na żywo?",
    answer:
      "Jeśli gram na imprezie otwartej lub publicznej – z przyjemnością Was zaproszę. Na zamknięte imprezy niestety nie ma takiej możliwości."
  },
  {
    question: "Czy oferujesz dekorację światłem?",
    answer:
      "Tak – dekoracja światłem to jedna z moich specjalizacji. Dzięki niej sala zyskuje niepowtarzalny klimat dopasowany do stylu przyjęcia."
  },
  {
    question: "Czy można wydłużyć czas grania w trakcie imprezy?",
    answer:
      "Tak, jeśli będzie taka potrzeba – za zgodą organizatorów i za ustaloną dopłatą mogę przedłużyć granie nawet do rana."
  }
];

export default function Pytania() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  return (
    <PageWrapper>
      <Helmet>
        <title>Najczęściej zadawane pytania – DJ Kusy</title>
        <meta
          name="description"
          content="Najczęstsze pytania par młodych i organizatorów imprez. DJ Kusy odpowiada na wątpliwości dotyczące rezerwacji, repertuaru i przebiegu imprez."
        />
        <link rel="canonical" href="https://djkusy.pl/pytania" />
        <meta property="og:title" content="DJ Kusy – FAQ i odpowiedzi" />
        <meta property="og:description" content="Odpowiedzi na pytania o DJ-a, imprezy, prowadzenie, atrakcje i rezerwację terminów. Sprawdź zanim zapytasz." />
        <meta property="og:image" content="https://djkusy.pl/og-image.webp" />
        <meta property="og:url" content="https://djkusy.pl/pytania" />
        <meta property="og:type" content="FAQPage" />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Breadcrumbs structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Strona główna",
                "item": "https://djkusy.pl/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Pytania",
                "item": "https://djkusy.pl/pytania"
              }
            ]
          })}
        </script>

        {/* FAQPage structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              ...faq.map(q => ({
                "@type": "Question",
                "name": q.question,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": q.answer
                }
              }))
            ]
          })}
        </script>
      </Helmet>

      <section id="hero" className="min-h-[70vh] bg-cover bg-center relative flex items-center justify-center text-white text-center px-4" style={{ backgroundImage: `url('/assets/zamkniete/zamkniete18.webp')` }}>
        <div className="absolute inset-0 bg-black opacity-60" />
        <div className="relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Najczęściej zadawane pytania</h1>
          <p className="text-lg text-gray-300 max-w-xl mx-auto">
            Zanim zapytasz — zobacz, co odpowiadam najczęściej.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white text-black px-6">
        <div className="max-w-4xl mx-auto space-y-6">
          {faq.map((item, i) => (
            <div key={i} className="border border-gray-300 rounded-lg shadow-sm overflow-hidden">
              <button
                onClick={() => toggle(i)}
                className="w-full text-left px-6 py-4 font-semibold text-lg flex justify-between items-center hover:bg-gray-50 transition"
              >
                {item.question}
                <span className="ml-4 text-2xl">{openIndex === i ? "−" : "+"}</span>
              </button>
              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="px-6 pb-6 text-gray-700 text-base leading-relaxed">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </section>

      <div className="py-24 text-center">
        <a href="/kontakt" className="inline-block bg-black text-white px-8 py-4 rounded-lg font-bold tracking-wide hover:bg-orange-500 transition">
          Nadal masz pytanie? Napisz do mnie!
        </a>
      </div>
    </PageWrapper>
  );
}
